module.exports = __webpack_public_path__ + "img/icon3.472c4374.png";